export class FeatureComponent<T> {
  features: T[] = [];

  constructor(public allFeatures: T[]) {
  }
}
